module.exports = __webpack_public_path__ + "fonts/iconfont.e4521ac0.ttf";